import { Bell } from 'lucide-react'

interface NotificationBadgeProps {
    count: number
    onClick?: () => void
    variant?: 'sidebar' | 'header'
}

export default function NotificationBadge({ count, onClick, variant = 'header' }: NotificationBadgeProps) {
    // Determine styles based on variant
    // Sidebar: Dark BG -> Gold Icon, White Hover
    // Header: Light BG -> Gold Icon, Blue Hover
    const iconColor = variant === 'sidebar'
        ? "text-[#d4a94d] group-hover:text-white"
        : "text-[#d4a94d] group-hover:text-[#001c28]"

    const containerClasses = variant === 'sidebar'
        ? "hover:bg-white/10"
        : "hover:bg-[#001c28]/5"

    return (
        <button
            onClick={onClick}
            className={`relative p-2.5 rounded-xl transition-all duration-300 group ${containerClasses}`}
        >
            <Bell className={`w-6 h-6 ${iconColor} transition-all duration-300 group-hover:scale-110 shadow-sm`} />

            {count > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-black rounded-full w-5 h-5 flex items-center justify-center animate-pulse ring-2 ring-white border border-red-600 shadow-md">
                    {count > 9 ? '9+' : count}
                </span>
            )}

            {/* Subtle glow effect for highlight */}
            <div className="absolute inset-0 rounded-xl bg-[#d4a94d]/20 opacity-0 group-hover:opacity-100 transition-opacity blur-md -z-10"></div>
        </button>
    )
}
